@use "../../../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .title {
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.375rem;
        margin-bottom: 0.75rem;
        color: colors.$mmc-slate;
      }

      .errorTitle {
        color: colors.$mmc-slate;
        margin-bottom: 0.5rem;
      }

      .errorDescription {
        color: colors.$mmc-slate;
        font-size: 0.875rem;
      }

      .popoverOverlay {
        :global(.ant-popover-inner-content) {
          width: min-content;
        }
      }
    }
  }
}
